import Vue from 'vue';
import VueRouter from 'vue-router';
import * as firebase from 'firebase/app';
import 'firebase/auth';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/presenter/home',
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: '/start',
  //   name: 'Start',
  //   component: () =>
  //     import(/* webpackChunkName: "Start" */ '../views/Start.vue'),
  // },
  /* For presenters */
  {
    path: '/presenter',
    component: () =>
      import(
        /* webpackChunkName: "PresenterRouterView" */ '../views/Presenter/RouterView.vue'
      ),
    children: [
      {
        path: 'signin',
        name: 'Presenter Signin',
        component: () =>
          import(
            /* webpackChunkName: "PresenterSignin" */ '../views/Presenter/Auth/Signin.vue'
          ),
      },
      {
        path: 'signup',
        name: 'Presenter Signup',
        component: () =>
          import(
            /* webpackChunkName: "PresenterSignup" */ '../views/Presenter/Auth/Signup.vue'
          ),
      },
      // {
      //   path: 'onboarding',
      //   name: 'Presenter Onboarding',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "PresenterOnboarding" */ '../views/Presenter/Auth/Signup.vue'
      //     ),
      //   meta: {
      //     requiresAuth: true,
      //   },
      //   children: [
      //     {
      //       path: 'first-step',
      //       name: 'Presenter Onboarding Step 1',
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "PresenterOnboardingStep1" */ '../views/Presenter/Auth/Signup.vue'
      //         ),
      //       meta: {
      //         requiresAuth: true,
      //       },
      //     },
      //     {
      //       path: 'second-step',
      //       name: 'Presenter Onboarding Step 2',
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "PresenterOnboardingStep2" */ '../views/Presenter/Auth/Signup.vue'
      //         ),
      //       meta: {
      //         requiresAuth: true,
      //       },
      //     },
      //   ],
      // },
      {
        path: 'home',
        name: 'Presenter Home',
        component: () =>
          import(
            /* webpackChunkName: "PresenterHome" */ '../views/Presenter/Home.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'sessions/new',
        name: 'New Presenter Session',
        component: () =>
          import(
            /* webpackChunkName: "NewPresenterSession" */ '../views/Presenter/NewSession.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'sessions/past',
        name: 'Past Sessions',
        component: () =>
          import(
            /* webpackChunkName: "PastSessions" */ '../views/Presenter/PastSessions.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
      /* For external tv */
      {
        path: 'sessions/:presenterSessionId/tv',
        redirect: '/viewer/sessions/:presenterSessionId/tv',
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'sessions/:presenterSessionId/edit',
        name: 'Presenter Session Edit',
        component: () =>
          import(
            /* webpackChunkName: "PresenterSessionEdit" */ '../views/Presenter/EditSession.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ':presenterSessionId/edit',
        name: 'Edit Session From Card',
        component: () =>
          import(
            /* webpackChunkName: "PresenterSessionEdit" */ '../views/Presenter/EditSession.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ':presenterSessionId/duplicate',
        name: 'Duplicate Session',
        component: () =>
          import(
            /* webpackChunkName: "PresenterSessionEdit" */ '../views/Presenter/DuplicateSession.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'sessions/:presenterSessionId',
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "PresenterSession" */ '../views/Presenter/Session.vue'
          ),
        children: [
          {
            path: '',
            name: 'Presenter Session Stats',
            component: () =>
              import(
                /* webpackChunkName: "PresenterSessionStats" */ '../views/Presenter/Session/Stats.vue'
              ),
            meta: {
              requiresAuth: true,
            },
          },
          // {
          //   path: 'analytics',
          //   name: 'Presenter Session Analytics',
          //   component: () =>
          //     import(
          //       /* webpackChunkName: "PresenterSessionAnalytics" */ '../views/Presenter/Session/Analytics.vue'
          //     ),
          //   meta: {
          //     requiresAuth: true,
          //   },
          // },
          {
            path: 'questions/settings',
            name: 'Settings',
            component: () =>
              import(
                /* webpackChunkName: "PresenterSessionQuestionSettings" */ '../views/Presenter/Session/Questions/Settings.vue'
              ),
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'questions',
            name: 'Presenter Session Questions',
            component: () =>
              import(
                /* webpackChunkName: "PresenterSessionQuestion" */ '../views/Presenter/Session/Questions.vue'
              ),
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'polls/settings',
            name: 'Presenter Session Poll Settings',
            component: () =>
              import(
                /* webpackChunkName: "PresenterSessionPollsSettings" */ '../views/Presenter/Session/Polls/Settings.vue'
              ),
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'polls',
            name: 'Presenter Session Polls',
            component: () =>
              import(
                /* webpackChunkName: "PresenterSessionPolls" */ '../views/Presenter/Session/Polls.vue'
              ),
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'polls/new',
            name: 'Presenter Session New Poll',
            component: () =>
              import(
                /* webpackChunkName: "PresenterSessionNewPoll" */ '../views/Presenter/Session/NewPoll.vue'
              ),
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'poll/:pollId/edit',
            name: 'Presenter Session Edit Poll',
            component: () =>
              import(
                /* webpackChunkName: "PresenterSessionEditPoll" */ '../views/Presenter/Session/EditPoll.vue'
              ),
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'wordclouds',
            name: 'Presenter Session Wordclouds',
            component: () =>
              import(
                /* webpackChunkName: "PresenterSessionWordclouds" */ '../views/Presenter/Session/Wordclouds.vue'
              ),
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'report',
            name: 'Presenter Session Report',
            component: () =>
              import(
                /* webpackChunkName: "PresenterSessionReport" */ '../views/Presenter/Session/Report.vue'
              ),
            meta: {
              requiresAuth: true,
            },
            children: [
              {
                path: '',
                redirect: '1',
              },
              {
                path: '1',
                name: 'Presenter Session Report Home',
                component: () =>
                  import(
                    /* webpackChunkName: "PresenterSessionReport" */ '../views/Presenter/Session/Report/Home.vue'
                  ),
              },
              {
                path: '2',
                name: 'Presenter Session Report Visible Questions',
                component: () =>
                  import(
                    /* webpackChunkName: "PresenterSessionReport" */ '../views/Presenter/Session/Report/VisibleQuestions.vue'
                  ),
              },
              {
                path: '3',
                name: 'Presenter Session Report Invisible Questions',
                component: () =>
                  import(
                    /* webpackChunkName: "PresenterSessionReport" */ '../views/Presenter/Session/Report/InvisibleQuestions.vue'
                  ),
              },
              {
                path: '4',
                name: 'Presenter Session Report Polls',
                component: () =>
                  import(
                    /* webpackChunkName: "PresenterSessionReport" */ '../views/Presenter/Session/Report/Polls.vue'
                  ),
              },
              {
                path: '5',
                name: 'Presenter Session Report Wordcloud',
                component: () =>
                  import(
                    /* webpackChunkName: "PresenterSessionReport" */ '../views/Presenter/Session/Report/Wordcloud.vue'
                  ),
              },
            ],
          },
        ],
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () =>
          import(
            /* webpackChunkName: "PresenterProfile" */ '../views/Presenter/Profile.vue'
          ),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/presenter/:uid',
    component: () =>
      import(
        /* webpackChunkName: "PresenterRouterView" */ '../views/Presenter/RouterView.vue'
      ),
    meta: {
      requiresAuth: false,
    },
    children: [
      {
        path: 'preferences',
        name: 'Presenter Preferences',
        component: () =>
          import(
            /* webpackChunkName: "PresenterPreferences" */ '../views/Presenter/Preferences.vue'
          ),
        children: [
          {
            path: 'email',
            name: 'Presenter Preferences Email',
            component: () =>
              import(
                /* webpackChunkName: "PresenterPreferencesEmail" */ '../views/Presenter/Preferences/Email.vue'
              ),
          },
        ],
      },
    ],
  },
  /* For external tv */
  {
    path: '/join/:sessionId/tv',
    redirect: '/viewer/sessions/:sessionId/tv',
  },
  /* For external moderators */
  {
    path: '/join/:sessionId/moderator',
    redirect: '/viewer/sessions/:sessionId/moderator',
  },
  /* For participants */
  {
    path: '/join/7YPQOcVC',
    redirect: '/viewer/sessions/7YPQOcVC/questions',
  },
  {
    path: '/join/:sessionId',
    redirect: '/viewer/sessions/:sessionId',
  },
  /* For Bibliomed DRG-Forum event */
  {
    path: '/j/drg-forum',
    redirect: '/viewer/sessions/drg-forum-live',
  },
  {
    path: '/j/drg-forum/*',
    redirect: '/viewer/sessions/drg-forum-live',
  },
  {
    path: '/viewer',
    component: () =>
      import(
        /* webpackChunkName: "ViewerRouterView" */ '../views/Viewer/RouterView.vue'
      ),
    children: [
      {
        path: 'sessions/:sessionId',
        name: 'Viewer Session',
        component: () =>
          import(
            /* webpackChunkName: "ViewerSession" */ '../views/Viewer/Session.vue'
          ),
        children: [
          {
            path: 'waiting-room',
            name: 'Viewer Session Waiting Room',
            component: () =>
              import(
                /* webpackChunkName: "ViewerSessionWaitingRoom" */ '../views/Viewer/SessionViews/WaitingRoom.vue'
              ),
          },
          {
            path: 'session-ended',
            name: 'Viewer Session Ended',
            component: () =>
              import(
                /* webpackChunkName: "ViewerSessionEnded" */ '../views/Viewer/SessionViews/SessionEnded.vue'
              ),
          },
          {
            path: 'review',
            name: 'Viewer Session Review',
            component: () =>
              import(
                /* webpackChunkName: "ViewerSessionReview" */ '../views/Viewer/SessionViews/Review.vue'
              ),
          },
          {
            path: 'review/success',
            name: 'Viewer Session Review Success',
            component: () =>
              import(
                /* webpackChunkName: "ViewerSessionReviewSuccess" */ '../views/Viewer/SessionViews/ReviewSuccess.vue'
              ),
          },
          {
            path: 'reactions',
            name: 'Viewer Session Reactions',
            component: () =>
              import(
                /* webpackChunkName: "ViewerSessionReactions" */ '../views/Viewer/SessionViews/Reactions.vue'
              ),
          },
          {
            path: 'paused',
            name: 'Viewer Session Paused',
            component: () =>
              import(
                /* webpackChunkName: "ViewerSessionPaused" */ '../views/Viewer/SessionViews/Pause.vue'
              ),
          },
          {
            path: 'info',
            name: 'Viewer Session Info',
            component: () =>
              import(
                /* webpackChunkName: "ViewerSessionInfo" */ '../views/Viewer/SessionViews/Info.vue'
              ),
          },
          {
            path: 'questions',
            name: 'Viewer Session Questions',
            component: () =>
              import(
                /* webpackChunkName: "ViewerSessionQuestion" */ '../views/Viewer/SessionViews/Questions.vue'
              ),
          },
          {
            path: 'questions/new',
            name: 'Viewer Session New Question',
            component: () =>
              import(
                /* webpackChunkName: "ViewerSessionNewQuestion" */ '../views/Viewer/SessionViews/NewQuestion.vue'
              ),
          },
          {
            path: 'polls',
            name: 'Viewer Session Polls',
            component: () =>
              import(
                /* webpackChunkName: "ViewerSessionPolls" */ '../views/Viewer/SessionViews/Polls.vue'
              ),
          },
          {
            path: 'wordclouds',
            name: 'Viewer Session Wordcloud',
            component: () =>
              import(
                /* webpackChunkName: "ViewerSessionWordcloud" */ '../views/Viewer/SessionViews/Wordcloud.vue'
              ),
          },
          {
            path: 'tv',
            name: 'Viewer Session TV',
            component: () =>
              import(
                /* webpackChunkName: "ViewerSessionTV" */ '../views/Presenter/TV.vue'
              ),
          },
          {
            path: 'moderator',
            name: 'Viewer Session Moderator',
            component: () =>
              import(
                /* webpackChunkName: "ViewerSessionModerator" */ '../views/Presenter/Moderator.vue'
              ),
          },
        ],
      },
    ],
  },
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '../views/404.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = firebase.auth().currentUser;

  if (to.path == '/presenter/signout') next({ name: 'Presenter Signin' });
  if (to.matched.some((route) => route.meta.requiresAuth) && !isAuthenticated) {
    next({ name: 'Presenter Signin', query: { redirect: to.path } });
  } else {
    next();
  }
});

// Always force to scroll to top of view
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

export { router };
